export default __webpack_public_path__ + "static/OBJECTS-5b3e650d2bcb77766b1d32a2c1b4dad6.svg";